export default "__VITE_ASSET__DMFRjurP__"